import axios from 'axios';
import { TOKEN_STORAGE_KEY } from './types';
import { LOCALE_STORAGE_KEY } from '../i18n';
import { resolveSystemApiBaseUrl } from './systemApiBaseUrl';

const baseURL = resolveSystemApiBaseUrl();

export const apiClient = axios.create({
  baseURL,
  // Fail hung upstreams (e.g. Stripe status) instead of blocking UI forever.
  timeout: 20_000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let onUnauthorized = null;

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const locale = localStorage.getItem(LOCALE_STORAGE_KEY) || 'sk';

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers['X-Locale'] = locale;

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && onUnauthorized) {
      onUnauthorized();
    }

    return Promise.reject(error);
  },
);
